import * as d3 from "d3";

export const tooltipPosition = (
  event: MouseEvent,

  container: d3.Selection<HTMLElement, unknown, any, any>,

  tooltip: d3.Selection<HTMLDivElement, unknown, any, any>,
) => {
  const containerNode = container.node() as HTMLElement;
  if (!containerNode) return;

  const pad = 8;

  const [mx, my] = d3.pointer(event as any, containerNode as any);
  const maxWidth = Math.max(0, containerNode.clientWidth - pad * 2);
  tooltip.style("max-width", `${maxWidth}px`);

  const ttNode = tooltip.node() as HTMLDivElement;
  const ttW = ttNode.offsetWidth || 0;
  const ttH = ttNode.offsetHeight || 0;
  const left = Math.max(
    pad,
    Math.min(mx + 3, containerNode.clientWidth - ttW - pad),
  );
  const top = Math.max(
    pad,
    Math.min(my + 10, containerNode.clientHeight - ttH - pad),
  );

  return { left, top };
};

export const bindTickTooltip = (
  selection: d3.Selection<SVGTextElement, unknown, any, any>,
  plotClassName: string,
  opts?: {
    displayedText?: string;
    fullText?: string;
  },
) => {
  selection

    .on("mouseover", function (event: MouseEvent, d: any) {
      const thisText = opts?.displayedText ?? d3.select(this).text();
      const fullText = opts?.fullText ?? "" + d;

      if (fullText === thisText) {
        return;
      }

      const container = d3.select(`.plot-container.${plotClassName}`);
      container.select(`.ticktooltip`).remove();

      const tooltip = container
        .append("div")
        .attr("class", "ticktooltip")
        .style("position", "absolute")
        .style("background-color", "white")
        .style("border", "1px solid #ddd")
        .style("padding", "3px")
        .style("border-radius", "5px")
        .style("z-index", "1000")
        .style("opacity", "0")
        .style("white-space", "normal")
        .style("word-break", "break-word")
        .style("pointer-events", "none");

      tooltip.html(`<p>${fullText}</p>`);
      const pos = tooltipPosition(
        event,
        container as unknown as d3.Selection<HTMLElement, unknown, any, any>,
        tooltip as unknown as d3.Selection<HTMLDivElement, unknown, any, any>,
      );
      if (!pos) return;

      tooltip
        .style("left", pos.left + "px")
        .style("top", pos.top + "px")
        .style("opacity", "1");
    })
    .on("mousemove", function (event: MouseEvent) {
      const container = d3.select(`.plot-container.${plotClassName}`);
      const containerNode = container.node() as HTMLElement;
      const tooltip = container.select(".ticktooltip");
      const ttNode = tooltip.node() as HTMLDivElement;
      if (!containerNode || !ttNode) return;

      const pos2 = tooltipPosition(
        event,
        container as unknown as d3.Selection<HTMLElement, unknown, any, any>,
        tooltip as unknown as d3.Selection<HTMLDivElement, unknown, any, any>,
      );
      if (!pos2) return;

      tooltip.style("left", pos2.left + "px").style("top", pos2.top + "px");
    })
    .on("mouseout", function () {
      d3.select(`.plot-container.${plotClassName} .ticktooltip`)
        .style("opacity", "0")
        .remove();
    });
};
